import {InitUploader} from './s3upload';
import {Error} from './model';
import {File as ExternalFile} from 'packages/files/models';
import {IsImage, ResizeImageFile} from 'packages/helpers/ImageUtils';
import CreateGUID from 'packages/helpers/CreateGUID';

const Bucket = 'dgtalguide-web';
const Prefix = 'external';

export async function UploadFile(
    File: File,
    OnCompelete: (res: [ExternalFile | null, Error | null]) => void,
    OnProgress?: (progress: number, progress_guid: string, file_size: number) => void
): Promise<string> {
    const progress_guid = CreateGUID();

    if (IsImage(File)) {
        try {
            File = await ResizeImageFile(File, 2000, 0.8);
        } catch (error) {
            console.error(error);
        }
    }
    // returns upload id
    return await InitUploader({
        bucket: Bucket,
        prefix: Prefix,
        file_name: File.name,
        file: File,
        on_progress: pregress => {
            if (typeof OnProgress === 'function') {
                OnProgress(pregress, progress_guid, File.size);
            }
        },
        on_complete: uploader => {
            OnCompelete([uploader.Result, uploader.Error]);
        },
    });
}

export function UploadFiles(
    Files: FileList,
    OnComplete: (res: [ExternalFile | null, Error | null][]) => void,
    OnProgress?: (progress: number) => void
) {
    let progressParts: Record<string, number> = {};
    let totalFilesSize = Array.from(Files).reduce((acc, file) => acc + file.size, 0);
    let completedCount = 0;
    let result: [ExternalFile | null, Error | null][] = [];

    const onComplete = (index: number) => (res: [ExternalFile | null, Error | null]) => {
        result[index] = res;
        completedCount += 1;
        if (completedCount === Files.length) {
            OnComplete(result);
        }
    };

    function onProgress(progress: number, progress_guid: string, file_size: number) {
        progressParts[progress_guid] = (progress * file_size) / totalFilesSize;
        if (typeof OnProgress === 'function') {
            OnProgress(Object.values(progressParts).reduce((a, b) => a + b, 0));
        }
    }

    let Promises: Promise<string>[] = [];
    for (let i = 0; i < Files.length; i++) {
        Promises.push(UploadFile(Files[i], onComplete(i), onProgress));
    }
}
